.root {
  border-radius: var(--metric-radius);
}

.metric {
  /* The single prominent grid hairline (#a7a7a7), matching the app-shell rails
     and tables. The colored selected-state border (set inline) still wins. */
  border-color: var(--mantine-color-default-border);

  &:not(:last-child):not(.isolatedFirst) {
    border-right: none;
  }

  &.isolatedFirst {
    border-bottom-right-radius: var(--metric-radius);
    border-top-right-radius: var(--metric-radius);
    margin-right: 6px;
  }

  &.nextOfIsolatedFirst {
    border-bottom-left-radius: var(--metric-radius);
    border-top-left-radius: var(--metric-radius);
  }

  &:last-child {
    border-bottom-right-radius: var(--metric-radius);
    border-top-right-radius: var(--metric-radius);
  }

  &:first-child {
    border-bottom-left-radius: var(--metric-radius);
    border-top-left-radius: var(--metric-radius);
  }
}
